// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Put styles to be applied globally here */

/* global custom properties */
:root {
  /* colors */
  --brand-primary: #337ab7;
  --default-border: #ccc;

  --danger-text: #a94442;
  --danger-bg: #f2dede;
  --danger-border: #ebccd1;

  --info-text: #31708f;
  --info-bg: #d9edf7;
  --info-border: #bce8f1;

  --warning-text: #8a6d3b;
  --warning-bg: #fcf8e3;
  --warning-border: #faebcc;

  --gray-darker: #222;
  --gray-dark: #333;
  --gray: #555;
  --gray-light: #777;
  --gray-lighter: #eee;

  /* layout (TODO: decide on and adopt a layout/grid system to replace bootstrap grid) */
  --container-padding: 0 15px;
}

.fa {
  margin-right: 0.5em;
}

.fa-right-icon {
  margin-left: 0.5em;
}

.fa-no-hover:hover {
  text-decoration: none;
}

/* global scaffolding and type styles copied from Bootstrap */
* {
  box-sizing: border-box;
}
*:before,
*:after {
  box-sizing: border-box;
}
html {
  font-size: 10px;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
body {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
  line-height: 1.42857143;
  color: var(--gray-darker);
  background-color: #fff;
}
input,
button,
select,
textarea {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}
a {
  color: #337ab7;
  text-decoration: none;
}
a:hover,
a:focus {
  color: #23527c;
  text-decoration: underline;
}
a:focus {
  outline: 5px auto -webkit-focus-ring-color;
  outline-offset: -2px;
}
figure {
  margin: 0;
}
img {
  vertical-align: middle;
}
[role="button"] {
  cursor: pointer;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: inherit;
  font-weight: 500;
  line-height: 1.1;
  color: inherit;
}

h1,
h2,
h3 {
  margin-top: 20px;
  margin-bottom: 10px;
}

h4,
h5,
h6 {
  margin-top: 10px;
  margin-bottom: 10px;
}

h1 {
  font-size: 36px;
}
h2 {
  font-size: 30px;
}
h3 {
  font-size: 24px;
}
h4 {
  font-size: 18px;
}
h5 {
  font-size: 14px;
}
h6 {
  font-size: 12px;
}
label {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 5px;
  font-weight: bold;
}
p {
  margin: 0 0 10px;
}
small {
  font-size: 85%;
}
ul,
ol {
  margin-top: 0;
  margin-bottom: 10px;
}
ul ul,
ol ul,
ul ol,
ol ol {
  margin-bottom: 0;
}
table {
  background-color: transparent;
  border-spacing: 0;
  border-collapse: collapse;
}
th {
  text-align: left;
}
/* end from Bootstrap */
`, "",{"version":3,"sources":["webpack://./src/css/global.css"],"names":[],"mappings":"AAAA,2CAA2C;;AAE3C,6BAA6B;AAC7B;EACE,WAAW;EACX,wBAAwB;EACxB,sBAAsB;;EAEtB,sBAAsB;EACtB,oBAAoB;EACpB,wBAAwB;;EAExB,oBAAoB;EACpB,kBAAkB;EAClB,sBAAsB;;EAEtB,uBAAuB;EACvB,qBAAqB;EACrB,yBAAyB;;EAEzB,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;;EAEpB,sFAAsF;EACtF,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,6DAA6D;AAC7D;EACE,sBAAsB;AACxB;AACA;;EAEE,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,6CAA6C;AAC/C;AACA;EACE,2DAA2D;EAC3D,eAAe;EACf,uBAAuB;EACvB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;;;;EAIE,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;;EAEE,cAAc;EACd,0BAA0B;AAC5B;AACA;EACE,0CAA0C;EAC1C,oBAAoB;AACtB;AACA;EACE,SAAS;AACX;AACA;EACE,sBAAsB;AACxB;AACA;EACE,eAAe;AACjB;AACA;;;;;;EAME,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;EAGE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;;EAGE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,aAAa;EACb,mBAAmB;AACrB;AACA;;;;EAIE,gBAAgB;AAClB;AACA;EACE,6BAA6B;EAC7B,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA,uBAAuB","sourcesContent":["/* Put styles to be applied globally here */\n\n/* global custom properties */\n:root {\n  /* colors */\n  --brand-primary: #337ab7;\n  --default-border: #ccc;\n\n  --danger-text: #a94442;\n  --danger-bg: #f2dede;\n  --danger-border: #ebccd1;\n\n  --info-text: #31708f;\n  --info-bg: #d9edf7;\n  --info-border: #bce8f1;\n\n  --warning-text: #8a6d3b;\n  --warning-bg: #fcf8e3;\n  --warning-border: #faebcc;\n\n  --gray-darker: #222;\n  --gray-dark: #333;\n  --gray: #555;\n  --gray-light: #777;\n  --gray-lighter: #eee;\n\n  /* layout (TODO: decide on and adopt a layout/grid system to replace bootstrap grid) */\n  --container-padding: 0 15px;\n}\n\n:global(.fa) {\n  margin-right: 0.5em;\n}\n\n:global(.fa-right-icon) {\n  margin-left: 0.5em;\n}\n\n:global(.fa-no-hover:hover) {\n  text-decoration: none;\n}\n\n/* global scaffolding and type styles copied from Bootstrap */\n* {\n  box-sizing: border-box;\n}\n*:before,\n*:after {\n  box-sizing: border-box;\n}\nhtml {\n  font-size: 10px;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\nbody {\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 14px;\n  line-height: 1.42857143;\n  color: var(--gray-darker);\n  background-color: #fff;\n}\ninput,\nbutton,\nselect,\ntextarea {\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\na {\n  color: #337ab7;\n  text-decoration: none;\n}\na:hover,\na:focus {\n  color: #23527c;\n  text-decoration: underline;\n}\na:focus {\n  outline: 5px auto -webkit-focus-ring-color;\n  outline-offset: -2px;\n}\nfigure {\n  margin: 0;\n}\nimg {\n  vertical-align: middle;\n}\n[role=\"button\"] {\n  cursor: pointer;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: inherit;\n  font-weight: 500;\n  line-height: 1.1;\n  color: inherit;\n}\n\nh1,\nh2,\nh3 {\n  margin-top: 20px;\n  margin-bottom: 10px;\n}\n\nh4,\nh5,\nh6 {\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\nh1 {\n  font-size: 36px;\n}\nh2 {\n  font-size: 30px;\n}\nh3 {\n  font-size: 24px;\n}\nh4 {\n  font-size: 18px;\n}\nh5 {\n  font-size: 14px;\n}\nh6 {\n  font-size: 12px;\n}\nlabel {\n  display: inline-block;\n  max-width: 100%;\n  margin-bottom: 5px;\n  font-weight: bold;\n}\np {\n  margin: 0 0 10px;\n}\nsmall {\n  font-size: 85%;\n}\nul,\nol {\n  margin-top: 0;\n  margin-bottom: 10px;\n}\nul ul,\nol ul,\nul ol,\nol ol {\n  margin-bottom: 0;\n}\ntable {\n  background-color: transparent;\n  border-spacing: 0;\n  border-collapse: collapse;\n}\nth {\n  text-align: left;\n}\n/* end from Bootstrap */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
